import React from 'react';
import type { ComponentProps } from 'react';
import { FibosearchCombobox } from './FibosearchCombobox';
export type ItemProps = ComponentProps<typeof FibosearchCombobox.Item> & {
  children: React.ReactNode;
};
export const BrandItem = ({
  children,
  ...props
}: ItemProps) => <FibosearchCombobox.Item display="flex" flexDirection="column" alignItems="flex-start" justifyContent="space-between" {...props} data-sentry-element="FibosearchCombobox.Item" data-sentry-component="BrandItem" data-sentry-source-file="Items.tsx">
    {children}
  </FibosearchCombobox.Item>;
export const ProductItem = ({
  children,
  ...props
}: ItemProps) => <FibosearchCombobox.Item display="flex" flexDirection="row" alignItems="center" gap={2.5} {...props} data-sentry-element="FibosearchCombobox.Item" data-sentry-component="ProductItem" data-sentry-source-file="Items.tsx">
    {children}
  </FibosearchCombobox.Item>;